import React, { useState, useEffect } from 'react'
import { isIosOrA } from '@/utils/utils'
import Annular from '@/components/annular'
import CountUp from 'react-countup'
import SimplePopover from '@/components/weekdatepopover'
import { fleetactAction } from '@/store/actions/fleetactAction'
import { connect } from 'react-redux'

import './index.scss'

const mapStateToProps = (state) => ({
    // 车队是否配置任务
    activityConfig : state.getIn(['fleetactReducer', 'activityConfig']),
    // 车队今日完成情况
    toDayActivityFlag: state.getIn(['fleetactReducer', 'toDayActivityFlag']),
    // 司机激活条件，完单数量
    activateCondition: state.getIn(['fleetactReducer', 'activateCondition']),
    // 司机完成人数
    activateCountReality: state.getIn(['fleetactReducer', 'activateCountReality']),
    // 司机目标人数
    activateCountTarget: state.getIn(['fleetactReducer', 'activateCountTarget']),

    // 今日人均完单子数是否考核
    driverAcceptOrderFlag: state.getIn(['fleetactReducer', 'driverAcceptOrderFlag']),
    // 今日人均完单子数
    driverAcceptOrderReality: state.getIn(['fleetactReducer', 'driverAcceptOrderReality']),
    // 今日人均完单子目标数
    driverAcceptOrderTarget: state.getIn(['fleetactReducer', 'driverAcceptOrderTarget']),

    // 车队总人数是否考核
    fleetCountFlag: state.getIn(['fleetactReducer', 'fleetCountFlag']),
    // 车队实际人数
    fleetCountReality: state.getIn(['fleetactReducer', 'fleetCountReality']),
    // 车队总人数目标人数
    fleetCountTarget: state.getIn(['fleetactReducer', 'fleetCountTarget']),

    // 在线时长是否考核
    onlineTimeFlag: state.getIn(['fleetactReducer', 'onlineTimeFlag']),
    // 在线实际
    onlineTimeReality: state.getIn(['fleetactReducer', 'onlineTimeReality']),
    // 在线目标
    onlineTimeTarget: state.getIn(['fleetactReducer', 'onlineTimeTarget']),

    // 人均流水是否考核
    payableAmountFlag: state.getIn(['fleetactReducer', 'payableAmountFlag']),
    // 人均流水实际
    payableAmountReality: state.getIn(['fleetactReducer', 'payableAmountReality']),
    // 人均流水目标
    payableAmountTarget: state.getIn(['fleetactReducer', 'payableAmountTarget']),

    // 车队达成天数
    reachDayReality: state.getIn(['fleetactReducer', 'reachDayReality']),
    // 车队达成目标天数
    reachDayTarget: state.getIn(['fleetactReducer', 'reachDayTarget']),


})
const mapDispatchToProps = (dispatch) => ({
    handleGetFleetAct() {
        return dispatch(fleetactAction());
    }
})
const FleetAward = ({ 
    handleGetFleetAct, 
    // 是否配置任务
    activityConfig,
    // 车队今日完成情况
    toDayActivityFlag,
    // 司机激活条件，完单数量
    activateCondition ,
    // 司机完成人数
    activateCountReality,
    // 司机目标人数
    activateCountTarget,

    // 今日人均完单子数是否考核
    driverAcceptOrderFlag,
    // 今日人均完单子数
    driverAcceptOrderReality,
    // 今日人均完单子目标数
    driverAcceptOrderTarget,

    // 车队总人数是否考核
    fleetCountFlag,
    // 车队实际人数
    fleetCountReality,
    // 车队总人数目标人数
    fleetCountTarget,

    // 在线时长是否考核
    onlineTimeFlag,
    // 在线实际
    onlineTimeReality,
    // 在线目标
    onlineTimeTarget,

    // 人均流水是否考核
    payableAmountFlag,
    // 人均流水实际
    payableAmountReality,
    // 人均流水目标
    payableAmountTarget,

    // 车队达成天数
    reachDayReality ,
    // 车队达成目标天数
    reachDayTarget,
    // 父组件的BScroll
    BScroll
    }) => {
    let [taskList, setTaskList] = useState([]);
    // 完成率封装
    const numPercent = (num1, num2) => {
        let res = ((num2 / num1) * 100).toFixed(1);
        return isNaN(res) ? 0 : res
    }
    const canvasSize = () => {
        if (isIosOrA()) {
            return '220%'
        } else {
            return '160%'
        }
    }
      
    //获取接口
    useEffect(() => {
        handleGetFleetAct()
        return () => { }
    },[handleGetFleetAct])
    
    //接口赋值构建数据
    useEffect(() => {
        
        // 赋值任务列表
        setTaskList(() => {
            let newArr = [
                {
                    txt: '车队人数',
                    targetNum: fleetCountTarget,
                    finishNum: fleetCountReality,
                    ischeck: fleetCountFlag,
                    unit: '人'
                },
                {
                    txt: '人均时长',
                    targetNum: onlineTimeTarget ,
                    finishNum: onlineTimeReality,
                    ischeck: onlineTimeFlag,
                    unit: '分钟'
                },
                {
                    txt: '人均完单数',
                    targetNum: driverAcceptOrderTarget,
                    finishNum: driverAcceptOrderReality,
                    ischeck: driverAcceptOrderFlag,
                    unit: '单'
                },
                {
                    txt: '人均流水',
                    targetNum: payableAmountTarget,
                    finishNum: payableAmountReality,
                    ischeck: payableAmountFlag,
                    unit: '元'
                },
            ]
            return [...newArr];
        })
    }, [toDayActivityFlag,activateCondition ,activateCountReality,activateCountTarget,driverAcceptOrderFlag,driverAcceptOrderReality, driverAcceptOrderTarget,fleetCountFlag,fleetCountReality,fleetCountTarget,onlineTimeFlag,onlineTimeReality,onlineTimeTarget,payableAmountFlag,payableAmountReality,payableAmountTarget,reachDayReality ,reachDayTarget])
    // 今日任务是动态加载，BScroll重新渲染
    useEffect( () => {
        if (!BScroll) return
        BScroll.refresh();
        return () => {}
    },[activityConfig])
    return (
        activityConfig?
        <div className='fleet-award__box'>
            <div className="fleet-task-tit">
                <h2>车队今日任务</h2>
                <em>{toDayActivityFlag?'恭喜，今日任务已经完成～':'今日车队任务尚未完成，继续加油哦～'}</em>
            </div>
            <div className="task-card-box">
                {
                    taskList.map((item, index) => (
                        <div className="task-card" key={index}>
                            <div className="task-card-top">
                                <h2>{item.txt}</h2>
                                <div className="annular-box">
                                    {
                                        item.ischeck ? <Annular canvasSize={canvasSize()} targetNum={item.targetNum} finishNum={item.finishNum} percent={numPercent(item.targetNum, item.finishNum)} /> : ''
                                    }
                                    
                                </div>
                            </div>
                            <div className='task-card-bottom'>
                                <h4> <CountUp start={0} end={item.finishNum || 0} decimals={index === 0 ? 0 : (index === 1 ? 0 : (index === 2 ? 1 : 2))} duration={1} /></h4>
                                <h5> / <span><CountUp start={0} end={item.targetNum || 0} decimals={0} duration={1} /></span><em>{item.unit}</em></h5>
                            </div>
                        </div>
                    ))
                }
            </div>

            <div className="fleet-task-tit">
                <h2>车队本周任务</h2>
            </div>
            <div className="fleet-task-info">
                <div className="week-task-info">
                    <p>
                        <span><CountUp start={0} end={reachDayReality || 0} duration={1} /></span>
                        <em>/ <CountUp start={0} end={reachDayTarget || 0} duration={1} />天</em>
                    </p>
                    <b>本周达成任务</b>
                </div>
                <div className="week-task-info">
                    <p>
                        <span><CountUp start={0} end={activateCountReality || 0} duration={2} /></span>
                        <em>/ <CountUp start={0} end={activateCountTarget || 0} duration={2} />人</em>
                    </p>
                    <b>
                        本周激活司机
                        <SimplePopover dateToday={'i'} turnover={`新司机完成${activateCondition || 0}单后激活`} />
                    </b>
                </div>
            </div>
        </div> : ''
    )
}
export default connect(mapStateToProps, mapDispatchToProps)(FleetAward)